export const constant = {
	container: '.swiper-container',
	paginator: '.swiper-pagination',
	buttonPrevious: '.swiper-button-prev',
	buttonNext: '.swiper-button-next',
}
